module.exports = __webpack_public_path__ + "static/media/Fold.6a019e79.gif";